import React from "react";
import { HouseholdWording } from "./householdWording";

interface WordingSettingsProps {
  wording: HouseholdWording;
  onChange: (wording: HouseholdWording) => void;
}

const WORDS = ["Jama'ah", "Jamaat", "Jamat", "Iqamah"];
const CUSTOM = "custom";

const SPELLINGS: { key: keyof NonNullable<HouseholdWording["names"]>; label: string; options: string[] }[] = [
  { key: "dhuhr", label: "Dhuhr", options: ["Dhuhr", "Zuhr", "Zohr"] },
  { key: "asar", label: "Asr", options: ["Asr", "Asar"] },
  { key: "isha", label: "Isha", options: ["Isha", "Esha"] },
  { key: "jummah", label: "Jumu'ah", options: ["Jumu'ah", "Jummah", "Jumuah"] },
];

// The household's own wording, like the clock's prayer call label: it wins over every masjid's.
const WordingSettings: React.FC<WordingSettingsProps> = ({ wording, onChange }) => {
  const word = wording.jamaat ?? WORDS[0];
  const isCustom = !WORDS.includes(word);

  const setName = (key: string, value: string) => {
    const names: Record<string, string> = { ...wording.names };
    if (value) names[key] = value;
    else delete names[key];
    onChange({ ...wording, names });
  };

  return (
    <div className="hs-wording">
      <label className="hs-field">
        <span>The congregation prayer is called</span>
        <select
          className="hs-select"
          value={isCustom ? CUSTOM : word}
          onChange={(e) =>
            onChange({
              ...wording,
              jamaat: e.target.value === CUSTOM ? "" : e.target.value === WORDS[0] ? undefined : e.target.value,
            })
          }
        >
          {WORDS.map((w) => (
            <option key={w} value={w}>
              {w}
            </option>
          ))}
          <option value={CUSTOM}>Your own…</option>
        </select>
      </label>
      {isCustom && (
        <label className="hs-field">
          <span>Your word (up to 12 letters)</span>
          <input
            className="hs-input"
            maxLength={12}
            value={word}
            onChange={(e) => onChange({ ...wording, jamaat: e.target.value })}
          />
        </label>
      )}
      {SPELLINGS.map(({ key, label, options }) => (
        <label key={key} className="hs-field">
          <span>Spell {label}</span>
          <select
            className="hs-select"
            value={wording.names?.[key] ?? ""}
            onChange={(e) => setName(key, e.target.value)}
          >
            <option value="">As each masjid spells it</option>
            {options.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
        </label>
      ))}
    </div>
  );
};

export default WordingSettings;
